import _axios from '../../apiClient'

export function getCalendario(payload) {
  return _axios.post(`/api/Turnero/GetCalendario`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getLocalidadesEntregaActivas() {
  return _axios.get(`/api/LocalidadEntrega/GetLocalidadesEntregaActivas`, {
    responseType: 'json',
    headers: { 
      'Accept': 'application/json'
    }
  })
  .then(response => {
    return response.data;
  })
  .catch((error) => {
    const data = error.response?.data || { message: 'Error desconocido' };
    throw data;
  });
}